<section id="Investments">
    <div class="row">
        <div class="title-section">
            <h3>صندوق های سرمایه گذاری</h3>
            <h6><a target="_blank" routerLink="/services/mutual-funds">صندوق
                    سرمایه گذاری مشترک چیست؟</a></h6>
        </div>
        <div class="body-section">
            <div class="column medium-6">
                <div class="inner">
                    <div class="image-container">
                        <img src="../../../assets/images/p.jpg">
                    </div>
                    <div class="text-container">
                        <h6>صندوق پارس</h6>
                        <p>اگر به دنبال سرمایه گذاری با ریسک متوسط می باشید، در این صندوق سرمایه گذاری کنید.</p>
                        <a target="_blank" routerLink="/services/pars-fund">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" routerLink="/services/pars-fund"></a>
                    </div>
                </div>
            </div>
            <div class="column medium-6">
                <div class="inner">
                    <div class="image-container">
                        <img src="../../../assets/images/a1.jpg">
                    </div>
                    <div class="text-container">
                        <h6>صندوق یکم آبان</h6>
                        <p>عمده منابع این صندوق در سهام شرکت ها سرمایه گذاری می شود و برای سرمایه گذاری با ریسک بالا
                            مناسب است.</p>
                        <a target="_blank" routerLink="/services/aban-yekom-fund">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" routerLink="/services/aban-yekom-fund"></a>
                    </div>
                </div>
            </div>

            <div class="column medium-6">
                <div class="inner">
                    <div class="image-container">
                        <img src="../../../assets/images/kosar.jpg">
                    </div>
                    <div class="text-container">
                        <h6>صندوق کوثر یکم</h6>
                        <p>این صندوق برای سرمایه‌گذاران کم ریسک که به دنبال دریافت سود ماهانه با نرخ مشخص هستند مناسب
                            می‌باشد</p>
                        <a target="_blank" routerLink="/services/kosar-yekom-fund">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" routerLink="/services/kosar-yekom-fund"></a>
                    </div>
                </div>
            </div>

            <div class="column medium-6">
                <div class="inner">
                    <div class="image-container">
                        <img src="../../../assets/images/roshd_paydar_aban.jpg">
                    </div>
                    <div class="text-container">
                        <h6>صندوق رشد پایدار آبان</h6>
                        <p>این صندوق قابل معامله در بورس میباشد و برای سرمایه گذاران کم ریسک که به دنبال دریافت سود
                            ماهیانه با نرخ مشخص هستند طراحی شده است</p>
                        <a target="_blank" routerLink="/services/roshd-paydar-fund">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" routerLink="/services/roshd-paydar-fund"></a>
                    </div>
                </div>
            </div>

            <div class="column medium-6">
                <div class="inner">
                    <div class="image-container">
                        <img src="../../../assets/images/neda_single_logo.jpg">
                    </div>
                    <div class="text-container">
                        <h6>صندوق ندای امید</h6>
                        <p>منافع حاصل از سرمایه گذاری منابع این صندوق صرف حمایت از بیماران سرطانی آذربایجان غربی می
                            گردد.</p>
                        <a target="_blank" routerLink="/services/omid-fund">بیشتر
                            بدانم</a>
                        <a class="right" target="_blank" routerLink="/services/pars-fund"></a>
                    </div>
                </div>
            </div>




        </div>
    </div>
</section>